import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function create(data) {
  const response = await http.postData("/checklist-persiapan-anestesi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/checklist-persiapan-anestesi/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/checklist-persiapan-anestesi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByLaporanOperasi(lapOpId: number) {
  const response = await http.getData(`/laporan-operasi/${lapOpId}/checklist-persiapan-anestesi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/checklist-persiapan-anestesi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPelaksana(id: number, data) {
  const response = await http.postData(`/checklist-persiapan-anestesi/${id}/sign-pelaksana`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signSupervisi(id: number, data) {
  const response = await http.postData(`/checklist-persiapan-anestesi/${id}/sign-supervisi`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/checklist-persiapan-anestesi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function print(id) {
  window.open(`${http.getAPI()}/checklist-persiapan-anestesi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  getByLaporanOperasi,
  find,
  signPelaksana,
  signSupervisi,
  destroy,
  print
};
